import { Injectable } from '@angular/core';
import { BehaviorSubject, delay, Observable, of, switchMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalLoadingBarService {
  readonly loadingState$ = new BehaviorSubject<boolean>(false);
  readonly pipedLoadingState$ = this.loadingState$.pipe(delay(0));
  private _activeLoadings = 0;

  private addLoading(): void {
    this._activeLoadings++;
    if (!this.loadingState$.value) {
      this.loadingState$.next(true);
    }
  }

  private removeLoading(): void {
    if (this._activeLoadings > 0) {
      this._activeLoadings--;
    }

    if (this.loadingState$.value && this._activeLoadings < 1) {
      this.loadingState$.next(false);
    }
  }

  handleLoadingProgress<T>(obs: Observable<T>): Observable<T> {
    let completed = false;

    const complete = () => {
      if (!completed) {
        this.removeLoading();
        completed = true;
      }
    };

    return of(null).pipe(
      tap(() => {
        this.addLoading();
      }),
      switchMap(() =>
        obs.pipe(
          tap({
            next: complete,
            error: complete,
            finalize: complete,
          })
        )
      )
    );
  }
}
